/**
 * 从后端获取的 form 范例
 * required 为 true 时不传 message 默认的文本是英文的。。
 */
export default [
  {
    type: 'input',
    key: 'name',
    required: true,
    label: '姓名',
    message: '让我们知道你是谁',
    placeholder: '您的名字'
  },
  {
    type: 'input',
    key: 'phone',
    required: true,
    label: '手机号',
    message: '为方便我们与你联系，请填写手机号码',
    placeholder: '请输入你的手机号'
  },
  {
    type: 'input',
    key: 'brand',
    required: true,
    label: '您的品牌名称？',
    message: '请输入您的品牌名称',
    placeholder: '品牌名称'
  },
  {
    type: 'radio',
    group: [
      { value: '3c数码', label: '3c数码' },
      { value: '食品', label: '食品' },
      { value: '美妆护肤', label: '美妆护肤' },
      { value: '家用电器', label: '家用电器' },
      { value: '鞋服箱包', label: '鞋服箱包' },
      { value: '家居家纺', label: '家居家纺' },
      { value: '日用百货', label: '日用百货' },
    ],
    key: 'category',
    required: true,
    label: '您的品牌所属类目？',
    message: '请选择您的品牌所属类目',
    placeholder: '请填写您的品牌所属类目'
  },
  {
    type: 'radio',
    group: [
      { value: '50元以下', label: '50元以下' },
      { value: '50-150元', label: '50-150元' },
      { value: '150-300元', label: '150-300元' },
      { value: '300元以上', label: '300元以上' },
    ],
    key: 'price',
    required: true,
    label: '您的品牌平均客单价？',
    message: '请选择您的品牌平均客单价',
    placeholder: '请选择您的品牌平均客单价'
  },
  {
    type: 'radio',
    group: [
      { value: '是', label: '是' },
      { value: '否', label: '否' },
    ],
    key: 'certification',
    required: true,
    label: '您的品牌是否通过国家指定质检部门认证？',
    message: '请选择是否通过认证',
    placeholder: '请选择'
  },
  {
    type: 'radio',
    group: [
      { value: '直营', label: '直营' },
      { value: '总代理', label: '总代理' },
      { value: '一级代理', label: '一级代理' },
      { value: '分销代理', label: '分销代理' },
    ],
    key: 'cooperation',
    required: true,
    label: '您的品牌合作方式？',
    message: '请选择您的品牌合作方式',
    placeholder: '请选择您的品牌合作方式'
  },
  {
    type: 'radio',
    group: [
      { value: '快手小店', label: '快手小店' },
      { value: '魔筷', label: '魔筷' },
      { value: '有赞', label: '有赞' },
      { value: '淘宝', label: '淘宝' }
    ],
    key: 'shop',
    required: true,
    label: '您的品牌店铺所属平台？',
    message: '请选择您的品牌店铺所属平台',
    placeholder: '请选择您的品牌店铺所属平台'
  },
  {
    type: 'textarea',
    key: 'example',
    required: true,
    label: '您的品牌主要合作主播（3-5人）',
    placeholder: '请填写合作过的主播',
    message: '请输入您需求的资源'
  }
];
